import axios from "axios";
import { handleGraphQLError, APiUrl } from "../helper";

export const getPricing = async () => {
    try {
        const response = await axios.post(
            APiUrl,
            {
                query: `query pricing { page(id: 87, idType: DATABASE_ID) { pricing { faq { title question1 { answer question } question2 { answer question } question3 { answer question } question4 { answer question } question5 { answer question } question6 { answer question } question7 { answer question } question8 { answer question } question9 { answer question } question10 { answer question } } feedback { card1 { description name pofileimage { node { sourceUrl } } postedtime ratingimage { node { sourceUrl } } role } card2 { description name pofileimage { node { sourceUrl } } postedtime role ratingimage { node { sourceUrl } } } card3 { description name pofileimage { node { sourceUrl } } postedtime role ratingimage { node { sourceUrl } } } card4 { description name pofileimage { node { sourceUrl } } postedtime role ratingimage { node { sourceUrl } } } card5 { description name pofileimage { node { sourceUrl } } postedtime role ratingimage { node { sourceUrl } } } title card6 { description name pofileimage { node { sourceUrl } } postedtime role ratingimage { node { sourceUrl } } } } reasonsToChooseUs { title card1 { title image { node { sourceUrl } } } card2 { title image { node { sourceUrl } } } card3 { title image { node { sourceUrl } } } } title staticImages { pricingbackground { description title file { node { sourceUrl } } description } salesfaqbackground { description title file { node { sourceUrl } } } } totalValue { description endline title image { node { sourceUrl } } } } title } }`,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        const json = response.data;
        console.log(json)
        if (json.errors) {
            handleGraphQLError(json.errors[0].message);
        } else {
            return json?.data?.page?.pricing ?? [];
        }
    } catch (err) {
        handleGraphQLError(err.message);
    }
};



